<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Has Type
            </h4>
            <p class="category font-weight-thin">
              Edit Fund Bucket Has Type
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="localFundBucketHasType.schema_name"
                v-validate="'required'"
                item-text="name"
                :items="schemas"
                label="Schema"
                :error-messages="errors.collect('schema_name')"
                data-vv-name="schema_name"
                data-vv-as="Schema"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="localFundBucketHasType.bucket_id"
                v-validate="'required'"
                item-text="fund_bucket.name"
                item-value="fund_bucket.id"
                :items="filteredBucketTypes"
                label="Bucket"
                :error-messages="errors.collect('bucket_id')"
                data-vv-name="bucket_id" 
                data-vv-as="Fund Bucket"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-model="localFundBucketHasType.type_id"
                v-validate="'required'"
                item-text="name"
                item-value="id"
                :items="fundBucketTypes"
                label="Fund Bucket Type"
                :error-messages="errors.collect('type_id')"
                data-vv-name="type_id"
                data-vv-as="Fund Bucket Type"
              />
            </v-col>
          </v-row>
                
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Edit
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      fundBucketHasType: Object,
    },

    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,

        localFundBucketHasType: '',
        schemas: [],
        fundBuckets: [],
        fundBucketTypes: [],
      }
    },
    computed: {
      filteredBucketTypes () {
        if (!this.localFundBucketHasType.schema_name) return
        
        return this.fundBuckets.filter(fundBucket => {
          return fundBucket.schema_name === this.localFundBucketHasType.schema_name
        })
      },
      isFundBucketHasTypeChanged () {
        return _.isEqual(this.fundBucketHasType, this.localFundBucketHasType)
      },
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.loadData()
          this.localFundBucketHasType = { ...this.fundBucketHasType }
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.companies().withSchema(),
          this.$api.fundBucketHasTypes().list(),
          this.$api.fundBucketTypes().list(),
        ])
          .then(([schemas, fundBuckets, fundBucketTypes]) => {
            schemas.data.map(item => {
              this.schemas.push(item.schema_name)
            })
            this.fundBuckets = fundBuckets.data
            this.fundBucketTypes = fundBucketTypes.data
            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            if (!this.isFundBucketHasTypeChanged) {
              this.$api.fundBucketHasTypes().update(this.localFundBucketHasType.id, this.prepareFormData())
                .then(response => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ color: 'success', message: response.data.message })

                    this.dialog = false
                  }
                }).catch(err => {
                  console.log(err)
                  this.$snack({ color: 'error', message: err.response.statusText })
                }).then(() => {
                  this.dialog = false
                  this.progressing = false
                })
            } else {
              this.$snack({ color: 'warning', message: 'No update has been done' })
              this.progressing = false
            }
          })
      },
      prepareFormData () {
        return {
          schema_name: this.localFundBucketHasType.schema_name,
          bucket_id: this.localFundBucketHasType.bucket_id,
          type_id: this.localFundBucketHasType.type_id,
        }
      },
    },
  }
</script>
